import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import AuthModal from '@/components/AuthModal';

const LoginPage = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <AuthModal
        open={open}
        onOpenChange={(v) => {
          setOpen(v);
          if (!v) navigate('/', { replace: true });
        }}
        onSuccess={() => navigate('/dashboard', { replace: true })}
        defaultTab="login"
      />
      {!open && null}
    </div>
  );
};

export default LoginPage;
